(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel {
    constructor(element) {
      this.carousel = element;
      this.prevBtn = this.carousel.parentElement.querySelector('.carousel-nav.prev');
      this.nextBtn = this.carousel.parentElement.querySelector('.carousel-nav.next');
      this.autoplay = this.carousel.getAttribute('data-autoplay') === 'true';
      this.autoplaySpeed = parseInt(this.carousel.getAttribute('data-autoplay-speed')) * 1000 || 5000;
      this.autoplayInterval = null;
      
      this.init();
    }

    init() {
      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.scroll('prev');
          this.resetAutoplay();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.scroll('next');
          this.resetAutoplay();
        });
      }

      // Mouse drag scrolling
      this.initDragScroll();

      // Pause autoplay on hover
      if (this.autoplay) {
        this.carousel.addEventListener('mouseenter', () => this.pauseAutoplay());
        this.carousel.addEventListener('mouseleave', () => this.startAutoplay());
        this.startAutoplay();
      }

      // Product cards click handling
      this.carousel.querySelectorAll('.product-card').forEach(card => {
        const imageWrapper = card.querySelector('.product-image-wrapper');
        const addToCartBtn = card.querySelector('[data-add-to-cart]');
        const variantSelect = card.querySelector('.variant-select');
        const productLink = imageWrapper.getAttribute('data-product-link');

        // Click on image or card (not button) goes to product page
        imageWrapper.addEventListener('click', (e) => {
          if (productLink) {
            window.location.href = productLink;
          }
        });

        card.querySelector('.product-title').addEventListener('click', (e) => {
          if (productLink) {
            window.location.href = productLink;
          }
        });

        // Variant select change
        if (variantSelect) {
          variantSelect.addEventListener('change', (e) => {
            const selectedOption = e.target.selectedOptions[0];
            const variantId = e.target.value;
            const price = selectedOption.getAttribute('data-price');
            const comparePrice = selectedOption.getAttribute('data-compare-price');
            
            // Update button variant ID
            addToCartBtn.setAttribute('data-variant-id', variantId);
            
            // Update prices
            const priceDisplay = card.querySelector('[data-price-display]');
            const comparePriceDisplay = card.querySelector('[data-compare-price-display]');
            
            if (priceDisplay && price) {
              priceDisplay.textContent = this.formatMoney(price);
            }
            
            if (comparePriceDisplay) {
              if (comparePrice && comparePrice > price) {
                comparePriceDisplay.textContent = this.formatMoney(comparePrice);
                comparePriceDisplay.style.display = 'inline';
              } else {
                comparePriceDisplay.style.display = 'none';
              }
            }

            // Update button state
            if (selectedOption.disabled) {
              addToCartBtn.disabled = true;
              addToCartBtn.textContent = 'Sold out';
            } else {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = 'Add to cart';
            }
          });
        }

        // Add to cart button
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.addToCart(addToCartBtn);
          });
        }
      });
    }

    initDragScroll() {
      let isDown = false;
      let startX;
      let scrollLeft;

      this.carousel.addEventListener('mousedown', (e) => {
        // Don't drag if clicking on buttons or select
        if (e.target.closest('button') || e.target.closest('select')) {
          return;
        }
        
        isDown = true;
        this.carousel.style.cursor = 'grabbing';
        startX = e.pageX - this.carousel.offsetLeft;
        scrollLeft = this.carousel.scrollLeft;
        this.resetAutoplay();
      });

      this.carousel.addEventListener('mouseleave', () => {
        isDown = false;
        this.carousel.style.cursor = 'grab';
      });

      this.carousel.addEventListener('mouseup', () => {
        isDown = false;
        this.carousel.style.cursor = 'grab';
      });

      this.carousel.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.carousel.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        this.carousel.scrollLeft = scrollLeft - walk;
      });

      // Set initial cursor
      this.carousel.style.cursor = 'grab';
    }

    scroll(direction) {
      const scrollAmount = 280;
      if (direction === 'prev') {
        this.carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        this.carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }

    async addToCart(button) {
      const variantId = button.getAttribute('data-variant-id');
      
      if (!variantId) return;

      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (response.ok) {
          button.textContent = 'Added!';
          
          // Trigger cart update event
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));

          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Error';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    }

    startAutoplay() {
      if (!this.autoplay) return;
      
      this.autoplayInterval = setInterval(() => {
        const maxScroll = this.carousel.scrollWidth - this.carousel.clientWidth;
        
        if (this.carousel.scrollLeft >= maxScroll - 10) {
          // Reset to beginning
          this.carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          // Scroll to next
          this.scroll('next');
        }
      }, this.autoplaySpeed);
    }

    pauseAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      this.pauseAutoplay();
      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    formatMoney(cents) {
      const amount = parseFloat(cents) / 100;
      return '$' + amount.toFixed(2);
    }
  }

  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(carousel => new ProductCarousel(carousel));
  });

  } catch(e) { console.error(e); }
})();
})();
